import { Breadcrumbs as BreadcrumbsMUI, Link, Typography } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import { useLocation, useNavigate } from "react-router-dom";





const classes = {
    link: {
        color: '#155BCB',
        fontWeight: 'bold',
    }
}

export default function Breadcrumbs({ paths }) {
    const from = useLocation().state?.from;
    const navigate = useNavigate();


    function handleClick(path) {
        if (from) {
            //Desempilha até chegar no item clicado
            while (from.pop().href !== path.href);

            //Redireciona para a página correta
            navigate(path.href, { state: from })
        }
    }

    const breadcrumbs = () => {
        const components = [
            <HomeIcon style={{ color: '#155BCB' }} key='home' />
        ];

        const n = paths.length - 1;
        for (let i = 0; i < n; i++) {
            const path = paths[i];

            components.push(
                <Link
                    underline="hover"
                    key={path.name}
                    href={path.href}
                    onClick={(e) => { e.preventDefault(); handleClick(path) }}
                    style={classes.link}
                >
                    {path.name}
                </Link>
            )
        }

        components.push(<Typography key="3" color="text.primary" style={{ fontWeight: 'bold' }}>
            {paths[n].name}
        </Typography>);

        return components;
    }

    return (
        <>
            <BreadcrumbsMUI
                separator={<NavigateNextIcon style={{ color: '#AEAEAE' }} fontSize="small" />}
                aria-label="breadcrumb"
            >
                {breadcrumbs()}
            </BreadcrumbsMUI>
        </>
    )
}